import React, { useState, useEffect } from 'react';

interface NotificationProps {
  message: string;
  type: 'success' | 'error';
  onClose?: () => void;
}

export const Notification: React.FC<NotificationProps> = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!visible && onClose) {
      const timeout = setTimeout(onClose, 300); // Wait for fade-out
      return () => clearTimeout(timeout);
    }
  }, [visible, onClose]);

  // Subtle color palette
  const typeStyles = {
    success: 'bg-green-50 border-green-300 text-green-900',
    error: 'bg-red-50 border-red-300 text-red-900',
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 min-w-[280px] max-w-xs shadow-xl rounded-lg border px-5 py-4 flex items-center gap-3 transition-all duration-300
        ${typeStyles[type]}
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
      role="alert"
      style={{ boxShadow: '0 8px 32px 0 rgba(60,60,60,0.10)' }}
    >
      <span className="flex-1 text-sm font-medium">{message}</span>
      {onClose && (
        <button
          onClick={() => setVisible(false)}
          className="ml-2 text-lg text-neutral-400 hover:text-neutral-700 transition-colors focus:outline-none"
          aria-label="Sluiten"
        >
          &times;
        </button>
      )}
    </div>
  );
};
